<template>
  <div class="content">
    <div class="top">
      <div class="top-header">
<!--        <div class="logo">-->
<!--          <p>有色金属会议平台</p>-->
<!--        </div>-->
        <div style="width: 100%;">
          <img src="@/assets/title.png" alt="">
        </div>

        <el-menu :default-active="activeIndex" text-color="#fff" background-color="#0363BA" active-text-color="#fff"    style="overflow: auto"
                 mode="horizontal">
          <el-menu-item @click="getMenuInformation(item.modularId)" v-for="item in menuList"
                        :index="item.modularId.toString()" :key="item.modularId">
            {{ item.modularName }}
          </el-menu-item>
          <el-menu-item index="2">Introduction</el-menu-item>
          <el-menu-item index="3">Papers Thematic</el-menu-item>
          <el-menu-item index="4">Conference Program</el-menu-item>
<!--          <el-submenu index="5">-->
<!--            <template slot="title">我的工作台</template>-->
<!--            <el-menu-item index="5-1">选项1</el-menu-item>-->
<!--            <el-menu-item index="5-2">选项2</el-menu-item>-->
<!--            <el-menu-item index="5-3">选项3</el-menu-item>-->
<!--          </el-submenu>-->
        </el-menu>

      </div>
    </div>

<!--    <div class="conference-img" style="width: 100%;height: 400px;">-->
<!--      <img src="@/assets/header.png" height="100%" width="100%" style="display:block;" alt="">-->
<!--    </div>-->
<!--    <div class="header">-->

      <!--      <el-row type="flex" justify="center">-->
      <!--        <el-col :span="16">-->
      <!--            <el-menu  :default-active="activeIndex"  text-color="white" style="overflow: auto"  mode="horizontal">-->
      <!--              <el-menu-item @click="getMenuInformation(item.modularId)" v-for="item in menuList"  :index="item.modularId.toString()" :key="item.modularId">-->
      <!--                {{item.modularName}}-->
      <!--              </el-menu-item>-->
      <!--            </el-menu>-->
      <!--        </el-col>-->
      <!--        <el-col :span="6" style="display: flex;padding: 20px 0px">-->
      <!--          <el-button type="primary" @click="toSignUpBody">T o sign up<i class="el-icon-edit-outline"></i></el-button>-->
      <!--          <el-button type="primary" @click="toSetHotel">Hotel reservation<i class="el-icon-edit-outline"></i></el-button>-->
      <!--          <el-button type="primary" @click="toPersonCenter">Person center<i class="el-icon-upload el-icon&#45;&#45;right"></i></el-button>-->
      <!--            <el-button type="primary" @click="toPersonCenter">{{-->
      <!--                isLogin?'Personal Center':'Registration'-->
      <!--                }}<i class="el-icon-upload el-icon&#45;&#45;right"></i></el-button>-->
      <!--          <el-button type="primary" @click="toUpload">Submit Abstracts<i class="el-icon-upload el-icon&#45;&#45;right"></i></el-button>-->
      <!--        </el-col>-->
      <!--      </el-row>-->
<!--    </div>-->
    <!--    <div class="img" style="width: 100%;height: 400px;padding-top: 68px">-->
    <!--      <img :src="'https://member.ysjszk.com:8666'+poster" height="100%" width="100%" style="display:block;" alt="">-->
    <!--    </div>-->
    <!--    <div class="body" style="height: 100%;width: 100%;background-color: white;margin: 0 auto;padding-top: 20px;padding-bottom: 35px">-->
    <div class="body" style="width: 100%;background-color: white;">
      <router-view/>
    </div>
  </div>
</template>
<script>
import vueQr from "vue-qr";
import th from "element-ui/src/locale/lang/th";

export default {
  name: "signUp",
  components: {
    vueQr
  },
  data() {
    return {
      id: '',
      poster: '',
      menuList: [],
      activeIndex: '1',
      modularId: '',
      //二维码
      imgUrl: require("../assets/logo1.jpg"),
      img: '',
      dataForm:[],
      isLogin:''

    }
  },
  methods: {
    async getHotMeting(){
      const { data: res } = await this.$http.get('api/conference/confDetailed/user/hotListLimit5')
      // console.log(res,"会议");
      if(res.code === 200 ){
        this.dataForm =  res.data
        await this.toSignUp(this.id)
      }else{
        this.$message.error(res.msg)
      }
    },
    async toSignUp(id){
      let routeData = this.$router.resolve({ path: '/signup',query:{id:id}
      });
      window.open(routeData.href, '_blank');
    },
    toSignUpBody() {
      // this.$router.push('/signUp/signUpBody',{query:{id:this.id}})
      let routeData = this.$router.resolve(
          {
            path: '/signUp/signUpBody',
            query: {id: this.id}

          });
      window.open(routeData.href, '_self');
    },
    toPersonCenter() {
      let routeData = this.$router.resolve(
          {path: '/person', query: {id: this.id}});
      window.open(routeData.href, '_blank');
    },
    toUpload() {
      let routeData = this.$router.resolve(
          {
            path: '/signUpLoad',
            query: {id: this.id}
          });
      window.open(routeData.href, '_self');
    },
    toSetHotel() {
      let routeData = this.$router.resolve(
          {
            path: '/setHotel',
            query: {id: this.id}
          });
      window.open(routeData.href, '_self');
    },
    async getInformation() {
      if (!this.id) {
        console.error("getMenuList: this.id 未定义");
        return;
      }
      const {data: res} = await this.$http.get('api/conference/confDetailed/user/' + 17)
      // console.log(res,111);
      // this.poster = res.data.poster
      // console.log(this.poster)
      this.img = res.data.codeUrl
    },
    //获取导航栏
    async getMenuList() {
      const {data: res} = await this.$http.get('api/conference/confDetailed/user/modularList/' + this.id)
      // console.log(res);
      if (res.code === 200) {
        if (res.data.length > 0) {
          this.menuList = res.data
          console.log(this.menuList,"list")
          this.activeIndex = res.data[0].modularId.toString()
          this.modularId = res.data[0].modularId
          this.getMenuInformation(res.data[0].modularId)
        } else {
          return this.$message.error('The meeting has no information at the moment')
        }
      } else {
        return this.$message.error(res.msg)
      }
    },
    //切换导航具体信息
    async getMenuInformation(modularId) {
      const {data: res} = await this.$http.get('api/conference/confDetailed/user/modular/' + modularId)
      // console.log(res);
      if (res.code === 200) {
        let routeData = this.$router.resolve(
            {
              path: '/signUp/signUpInformation',
              query: {id: this.id, modularId: modularId}
            });
        window.open(routeData.href, '_self');
      } else {
        return this.$message.error(res.msg)
      }
    },
  },
  created() {
    this.id=17
    this.modularId=40
    this.getHotMeting()
    this.isLogin = window.localStorage.getItem('token' + this.id)
  },
  mounted() {
    this.getMenuList()
    this.getInformation()
  }
}
</script>

<style scoped lang="less">
.content {
  position: absolute;
  top: 0;
  left: 15%;
  right: 15%;
  display: flex;
  flex-direction: column;
  // width: 1075px;
  height: 100%; /* 确保内容占满可用高度 */
}

.top-header{
  width: 100%;
  //height: 128px;
  //background-color: #1B3546;
  img{
    width: 100%;
    vertical-align: middle;
    border-style: none;
  }
}
.logo{
  width: 200px; /* 设置容器宽度 */
  height: 80px; /* 设置容器高度 */
  overflow: hidden; /* 隐藏溢出部分 */
  border-radius: 50%; /* 圆形边框 */
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFFFFF;
  font-size: large;
}

.header {
  text-align: center;
  line-height: 68px;
  height: 68px;
  width: 100%;
  top: 0;
  z-index: 999;
}


//.el-menu {
//  height: 68px;
//  width: 100%;
//}
//.el-menu-item {
//  height: 68px;
//}

//.el-menu--horizontal > .el-menu-item {
//  line-height: 68px;
//  height: 68px;
//  color: #ffffff;
//  font-size: 18px;
//}
//
///deep/ .el-menu--horizontal > .el-menu-item.is-active {
//  border-bottom: 2px solid #409EFF;
//  color: #ffffff;
//}
//
///deep/ .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover {
//  border-bottom: 2px solid #409EFF;
//  color: #ffffff;
//}
//.el-menu--horizontal .el-menu-item:not(.is-disabled):focus{
//  color: #ffffff;
//}
a {
  font-size: 16px;
  text-decoration: none;
}

a:hover {
  color: red;
}
</style>
